import React, { useEffect, useState } from "react"
import PromotionBar from "./snippets/PromotionBar"
import ModulesLotteryDraw from "./promotions/promotion_modules/modules_lotterDraw"
import ModuleRaceOfReels from "./promotions/promotion_modules/ModuleRaceOfReels"
import { usePromotionsPage, hiddenBtnTitles } from "./data/usePromotionsPage"
import { useLocation } from "react-router-dom"
import ModuleBNGSplash from "./promotions/promotion_modules/ModuleBNGSplash"
import ModulesPeraBayong from "./promotions/promotion_modules/modules_peraBayong"
import ModuleJiliGrandSlot from "./promotions/promotion_modules/ModuleJiliGrandSlot"
import ModuleRainOfWins from "./promotions/promotion_modules/ModuleRainOfWins"
import RollingCommission from "./promotions/RollingCommission"
import ModuleJDBWinnersLeague from "./promotions/promotion_modules/ModuleJDBWinnersLeague"

const modalComponents = {
  "2/30 Lottery Draw": ModulesLotteryDraw,
  "Race of Reels: Slots Tournament": ModuleRaceOfReels,
  "BNG Splash Spin Into Summer": ModuleBNGSplash,
  "Jili Grand Slot": ModuleJiliGrandSlot,
  "Rain Of Wins": ModuleRainOfWins,
  "Pera O Bayong": ModulesPeraBayong,
  "JDB's Winners League": ModuleJDBWinnersLeague,
}

export default function AppPromo({ isLightMode }) {
  const {
    uniqueFilters,
    isMobile,
    currentFilter,
    handleFilterChange,
    isAnimating,
    filteredPromotions,

    isLoggedIn,
    showMysteryFridayBtn,
    doubleUpMaxAmount,
    doubleUpTurnover,

    setIsDepositOpen,
    setIsShowDoubleUp,
    setIsShowViewEntry,

    ActiveModal,
    setActiveModal,
    handlePeraOBayong,
    handleLeaderboard,
    handlePrimaryBtnClick,
  } = usePromotionsPage({
    modalComponents,
  })

  const [showRolling, setShowRolling] = useState(false)

  const location = useLocation()
  const isAppPromo = location.pathname.startsWith("/app-promotion")

  useEffect(() => {
    const isAppPromotion = location.pathname.startsWith("/app-promotion")

    if (isAppPromotion) {
      const theme = isLightMode ? "light" : "dark"
      document.documentElement.dataset.theme = theme
      localStorage.setItem("theme", theme)
    }
  }, [location.pathname])

  return (
    <>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}

      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-page-content">
            <h1 className="fgh-h1-style normal-margin-bottom">
              Exclusive Casino Bonuses Just for You
            </h1>
            <label className="fgh-normal-label-style standard-margin-bottom">
              Your Offers Are In – Don’t Miss Out
            </label>

            {!!uniqueFilters.length && (
              <div className="promotion-page-filter">
                {isMobile ? (
                  <select
                    value={currentFilter}
                    onChange={(e) => handleFilterChange(e.target.value)}
                  >
                    {uniqueFilters.map((f, i) => (
                      <option key={i} value={f}>
                        {f}
                      </option>
                    ))}
                  </select>
                ) : (
                  <ul>
                    {uniqueFilters.map((f, i) => (
                      <li
                        key={i}
                        className={`promotion-filter-status ${
                          currentFilter === f ? "active" : ""
                        }`}
                        onClick={() => handleFilterChange(f)}
                      >
                        {f}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            <div
              className={`promotion-items-container ${
                isAnimating ? "promotion-fade-out" : "promotion-fade-in"
              }`}
            >
              {filteredPromotions.map((data) => {
                const showBtn =
                  !!data.btnTxt &&
                  isLoggedIn &&
                  !hiddenBtnTitles.has(data.title)

                const canPlayDoubleUp =
                  data.title === "Double Up" &&
                  isLoggedIn &&
                  doubleUpMaxAmount &&
                  doubleUpTurnover >= 100000

                return (
                  <div key={data.id} className="promotion-item">
                    <div className="promotion-image">
                      <img src={data.imgSrc} alt={data.title} />
                      <div className="promotion-image-overlay" />
                    </div>

                    {data.status && (
                      <div
                        className={`promotion-item-ribbon ${data.promotionMessage.class}`}
                      >
                        {data.promotionMessage.text}
                      </div>
                    )}

                    <div className="promotion-item-content">
                      <div className="promotion-info">
                        <h2>{data.title}</h2>
                        <label>{data.subHeading}</label>
                      </div>

                      <div className="promotion-cta">
                        {showMysteryFridayBtn &&
                          data.title === "Pera O Bayong" && (
                            <button onClick={handlePeraOBayong}>
                              Claim Your Prize
                            </button>
                          )}

                        {isLoggedIn &&
                          !isAppPromo &&
                          [
                            "King of the Reels",
                            "FC Grand Spin-Ale",
                            "Flexi-Spin Showdown",
                            "CQ9 Funalo",
                            "JDB Exclusive Promo",
                            "Race of Reels: Slots Tournament",
                            "BNG Splash Spin Into Summer",
                            "Jili Grand Slot",
                          ].includes(data.title) && (
                            <button
                              onClick={() => handleLeaderboard(data.title)}
                            >
                              Leaderboard
                            </button>
                          )}

                        {isLoggedIn && data.title === "8PM Recovery Hour" && (
                          <button
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsDepositOpen(true)}
                          >
                            Deposit Now
                          </button>
                        )}

                        {canPlayDoubleUp && (
                          <button
                            onClick={() => {
                              setIsShowDoubleUp(false)
                              setTimeout(() => setIsShowDoubleUp(true), 0)
                            }}
                          >
                            Play Now
                          </button>
                        )}

                        {data.title === "8's Your Lucky Draw" && isLoggedIn && (
                          <button onClick={() => setIsShowViewEntry(true)}>
                            View Entry
                          </button>
                        )}

                        {data.title === "Exclusive Rolling Commission" &&
                          !isAppPromo &&
                          isLoggedIn && (
                            <button
                              onClick={() => setShowRolling(!showRolling)}
                            >
                              View
                            </button>
                          )}

                        {!!data.btnTxt && (
                          <>
                            {data.title === "Saturday Spin Surprize" && (
                              <PromotionBar />
                            )}

                            {showBtn && !isAppPromo && (
                              <button
                                style={{ display: showBtn ? "block" : "none" }}
                                onClick={() => handlePrimaryBtnClick(data)}
                              >
                                {data.btnTxt}
                              </button>
                            )}
                          </>
                        )}

                        <a
                          href={
                            isAppPromo
                              ? data.tncLink.replace(
                                  "/promotion",
                                  "/app-promotion"
                                )
                              : data.tncLink
                          }
                        >
                          Details
                        </a>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
      {showRolling && (
        <RollingCommission onClose={() => setShowRolling(false)} />
      )}
    </>
  )
}
